/**
 * Console logging backend
 * Logs to standard console output (stderr for errors, stdout for others)
 *
 * This backend always runs as a fallback, ensuring logs are visible
 * even if external services (BetterStack, Sentry) are unavailable
 */
export class ConsoleBackend {
    /**
     * Send log entry to console
     * Uses appropriate console method based on log level
     */
    send(entry) {
        const method = entry.level === "ERROR" ? "error" : entry.level === "WARN" ? "warn" : "log";
        // Log as JSON for structured output
        // This makes it easier to parse logs in Cloudflare Workers dashboard
        // eslint-disable-next-line no-console
        console[method](JSON.stringify(entry));
    }
}
//# sourceMappingURL=console.js.map